import React from 'react';
import PropTypes from 'prop-types';
import './EventCard.scss';
import Icon from 'components/Icon';
import cn from 'classnames';
import { Media } from 'components/Media';

class EventCard extends React.Component {

    static propTypes = {
        event: PropTypes.shape({
            image: PropTypes.string,
            title: PropTypes.string,
            date: PropTypes.string,
            area: PropTypes.string,
        }).isRequired,
        close: PropTypes.function,
        closeLabel: PropTypes.string,
        monthNames: PropTypes.array.isRequired,
        link: PropTypes.shape({
            href: PropTypes.string.isRequired,
            target: PropTypes.string,
            text: PropTypes.string.isRequired,
            title: PropTypes.string,
        }),
    }

    _getMonth = thedate => {
        var monthNames = this.props.monthNames;
        var theDate = thedate.split(".");
        var newDate = monthNames[parseInt(theDate[1])-1] + " " + theDate[2];
        return newDate;
    }
   
    render() {
        const event = this.props.event;
        const closeLabel = this.props.closeLabel;
        const link = this.props.link;

        return (
            <div className={cn("event-card", {
                "event-card_no-image": !event.image
            })}>
                {event.image && (
                    <div className="event-card__image">
                        <Media
                        image={event.image}
                        alt={event.title ? event.title : ''}
                    />
                    </div>
                )}
                <div className="event-card__text-content">
                    <h3 className="title">{event.title}</h3>
                    <div className="event-card__date">{this._getMonth(event.date)}</div>
                    {event.description && (
                        <p className="event-card__area">{event.description}</p>
                    )}
                    {this.props.close && (
                        <button
                            className="event-card-close"
                            onClick={this.props.close}
                        >
                            <Icon icon="close" />
                            <span>{closeLabel}</span>
                        </button>
                    )}
                    {link && link.href &&
                        <a
                            href={link.href}
                            title={link.title}
                            target={link.target ? link.target : null}
                            rel={link.target && link.target === "_blank" ? "noopener noreferrer" : null}
                        >{link.text}</a>
                    }
                </div>
            </div>
        );
    }
}

export default EventCard;



// WEBPACK FOOTER //
// ./src/components/EventCard/EventCard.jsx